import { stripStatePrefix } from './tenant';

// Paths of auth screens that have been removed: the Auth0-era personal-info
// and pending-verification screens, and the old password-setup screen. Old
// emailed links and bookmarks to them go to sign-in.
export const RETIRED_AUTH_PATHS = ['/personal-info', '/verification-email', '/setup-password', '/verified'];

// The old password-setup links carried a one-time code in the query string,
// either on a retired path or on the root (`/?user_id=..&code=..&email=..`).
const SETUP_LINK_PARAMS = ['user_id', 'code', 'email'];

/**
 * Where an old link to a retired auth screen should land, or null if the
 * location is not one. Other query params (e.g. `ref`) and the hash are kept;
 * the setup link's one-time code and identifiers are dropped.
 */
export function retiredAuthRedirectTarget({ pathname, search = '', hash = '' }) {
  const path = stripStatePrefix(pathname);
  const params = new URLSearchParams(search);
  const isRetiredPath = RETIRED_AUTH_PATHS.includes(path);
  const isRootSetupLink = path === '/' && SETUP_LINK_PARAMS.every((key) => params.has(key));
  if (!isRetiredPath && !isRootSetupLink) return null;

  SETUP_LINK_PARAMS.forEach((key) => params.delete(key));
  const query = params.toString();
  return `/login${query ? `?${query}` : ''}${hash}`;
}

/**
 * Rewrite the URL of an old retired-screen link to /login before the app
 * renders, so the layout, auth flow and router all see the sign-in URL from
 * the start (a redirect inside the router comes too late for the layout).
 */
export function redirectRetiredAuthUrl() {
  if (typeof window === 'undefined') return;
  const target = retiredAuthRedirectTarget(window.location);
  if (target) {
    window.history.replaceState(window.history.state, '', target);
  }
}
